var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSignIninline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 6.5,
  r: 6,
  stroke: "#252829"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 16h4a7 7 0 0 1 7 7v1h1v-1a8 8 0 0 0-8-8h-4a8 8 0 0 0-8 8v1h1v-1a7 7 0 0 1 7-7Z",
  fill: "#252829"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm1 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM21 23a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1H2v-1a8 8 0 0 1 8-8h4a8 8 0 0 1 8 8v1h-1v-1Z",
  fill: "#252829"
})));
export default SvgSignIninline;